import ProfileImage from "../../assets/images/user.png";
import profileIcon from "../../assets/images/profile.png";
import logoutIcon from "../../assets/images/logout.png";
import email from "../../assets/images/email.png";
import call from "../../assets/images/call.png";
import Navbar from "./navbar.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../../utils/auth";
import axios from "axios";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

const NavbarTop = () => {
  const role = getUserRole();  
  const [username, setUsername] = useState("");
  const [publisherData, setPublisherData] = useState("");
  const [loading, setLoading] = useState(true); // Track loading state
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation(); 
  const navigate = useNavigate();
  // showing user name
  const pubUserName = ()=>{
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }   
    }
    const pubLogOut = async (e)=>{
      e.preventDefault();
      try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/pub/logout`, 
          {}, 
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Accept" : "application/json",
              "Content-Type": "application/json",
            },
            // withCredentials: true,
          }
        )
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("userRole");
        localStorage.removeItem("account_id");
        navigate("/");

        // });
      } catch (error) {}
    }  
    const adminLogOut = async (e)=>{
      e.preventDefault();
      try {
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/logout`, 
          {}, 
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Accept" : "application/json",
              "Content-Type": "application/json",
            },
            // withCredentials: true,
          }
        )
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("userRole");
        navigate("/admin");

        // });
      } catch (error) {}
    } 
    const accountId = localStorage.getItem("account_id");
    const userName = localStorage.getItem("username");
    const fetchPublisher = async () => {
      // if (!accountId) {
      //   console.error("Account ID is missing!");
      //   return; // Exit if no accountId is available
      // }
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/getPublisher/${accountId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (response?.data?.data?.length > 0) {
          setPublisherData(response?.data?.data[0]?.account_name || "N/A");
        } else {
          setPublisherData("No account name available");
        }
      } catch (error) {
        // if (error.response?.status === 401) {
        //   console.error("Unauthorized! Token might be expired.");
        //   localStorage.removeItem("token");
        //   navigate("/");
        // }
        console.error("Error fetching publisher:", error);
      } finally {
        setLoading(false); // Set loading to false after API call
      }
    };
    
   useEffect(() => {
    pubUserName();
    fetchPublisher();
    // pubLogOut();
  });

  // const token = localStorage.getItem("token");
  //   if (token) {
  //     setIsLoggedIn(true);
  //   } else {
  //     setIsLoggedIn(false);
  //   }
  // Hide sidebar on login page 
  if (location.pathname === "/") {
    return null;
  }
  if (location.pathname === "/admin") {
    return null;
  }
  // if (!isLoggedIn) {
  //   return null; // Don't render Navbar if the user is not logged in
  // }
  return (
    <div className="navbar-header shadow-sm p-3 bg-white rounded">
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-4">
            {/* <button
              className="btn btn-primary navbar-toggle collapsed"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasExample"
              aria-controls="offcanvasExample"
              data-target="#navbar"
              aria-expanded="false"
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button> */}
          </div>
        </div>

    
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-3 support">
            <Link to="mailto:support@adchronix.com">
              <img src={email} style={{ width: "20px" }} />{" "}
              support@adchronix.com
            </Link>
            {/* <Link to="tel:0000000000" style={{marginRight:"50px"}}><img src={call} style={{width:"20px", marginRight:"2px"}} />+91-0000-000-000</Link> */}
            <div className="dropdownNav">
              <button
                className="d-flex justify-content-center align-items-center rounded-circle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={ProfileImage}
                  alt="image"
                  className="w-40-px h-40-px object-fit-cover rounded-circle"
                />
              </button>
              <div className="dropdown-menu to-top dropdown-menu-sm">
                <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                  <div>
                    <h6
                      className="text-lg text-primary-light fw-semibold"
                      style={{ marginTop: "5px" }}
                    >
                      {/* {role !== "admin" ? publisherData : username} */}
                      {loading ? (
                        <span>Loading...</span> // Show loading message until data is fetched
                      ) : (
                        <span>
                          {role !== "admin" ? publisherData : userName}
                        </span>
                      )}
                    </h6>
                    {/* <span> { role }</span> */}
                    {/* <span className="text-secondary-light fw-medium text-sm">
                      Admin
                    </span> */}
                  </div>
                  {/* <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                  >
                  </button> */}
                </div>
                {role !== "admin" ? (
                  <ul className="to-top-list">
                    <li>
                      <span
                        className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                        onClick={() => navigate("/profile")}
                        style={{ cursor: "pointer" }}
                      >
                        <img src={profileIcon} /> My Profile
                      </span>
                    </li>
                    <li>
                      <p
                        className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                        to=""
                        onClick={pubLogOut}
                        style={{ cursor: "pointer" }}
                      >
                        <img src={logoutIcon} />
                        Log Out
                      </p>
                    </li>
                  </ul>
                ) : (
                  <ul className="to-top-list">
                    {/* <li>
                  <a
                    className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                    href="#"
                  >
                    <img src={profileIcon} /> My Profile
                  </a>
                </li> */}
                    <li>
                      <p
                        className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                        to=""
                        onClick={adminLogOut}
                        style={{ cursor: "pointer" }}
                      >
                        <img src={logoutIcon} />
                        Log Out
                      </p>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarTop;
